export default __webpack_public_path__ + "static/media/img_Hero.d61af0b7.jpg";